import React from 'react';
import { Container, Row, Col, Fade } from 'reactstrap';

import { OrganizationsTableCard } from '../../../containers/Cards/Organization';
const OrganizationsDashboard = () => (
  <Fade>
    <Container fluid className="mt-3">
      <Row>
        <Col>
          <OrganizationsTableCard></OrganizationsTableCard>
        </Col>
      </Row>
    </Container>
  </Fade>
);
export default OrganizationsDashboard;
